import { useTranslation } from 'react-i18next';
import { SearchIcon, SvgIcon } from '@make-software/cspr-design';
import { BodyText } from '@block-explorer/ui';
import React from 'react';
import styled from 'styled-components';

const FailedToFetchWrapper = styled('div')(({ theme, height = 400 }) => ({
  height: height,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledBodyText = styled(BodyText)(({ theme }) => ({
  marginTop: 8,
  color: theme.styleguideColors.contentSecondary,
}));

const StyledSvgIcon = styled(SvgIcon)(({ theme }) => ({
  path: {
    fill: theme.styleguideColors.fillPrimaryRed,
  },
  marginBottom: 20,
}));

export const FailedToFetch = ({ height }: { height?: number }) => {
  const { t } = useTranslation();
  return (
    <FailedToFetchWrapper height={height}>
      <StyledSvgIcon src={SearchIcon} size={60} />
      <BodyText scale={'lg'} lineHeight={'sm'} size={1}>
        {t('Failed to load data')}
      </BodyText>
      <StyledBodyText size={3}>{t('Please try again later')}</StyledBodyText>
    </FailedToFetchWrapper>
  );
};

export interface TableErrorProps {
  columnsLength?: number;
  height?: number;
}

export const TableError = ({ columnsLength, height }: TableErrorProps) => {
  return (
    <tr>
      <td colSpan={columnsLength}>
        <FailedToFetch height={height} />
      </td>
    </tr>
  );
};

export const NoDataFoundTableError = ({ columnsLength }) => {
  const { t } = useTranslation();
  return (
    <tr>
      <td colSpan={columnsLength}>
        <FailedToFetchWrapper>
          <StyledSvgIcon src={SearchIcon} size={60} />
          <BodyText scale={'lg'} lineHeight={'sm'} size={1}>
            {t('No data found')}
          </BodyText>
        </FailedToFetchWrapper>
      </td>
    </tr>
  );
};
